import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useEffect, useState } from 'react';
import { useStore } from 'react-redux';

import { isDogfoodPerfHUDEnabled } from './isEnabled';

export const useIsDogfoodPerfHUDEnabled = (): boolean => {
  'use memo';

  const [isEnabled, setIsEnabled] = useState(false);
  const state = useStore().getState();
  const treatmentCacheKey = useExperimentTreatmentWithoutReporting('DogfoodPerfHUD');

  useEffect(() => {
    const getExperimentState = async () => {
      const result = await isDogfoodPerfHUDEnabled(state);
      setIsEnabled(result);
    };
    getExperimentState();
  }, [state, treatmentCacheKey]);

  return isEnabled;
};
